/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Bot: 'Bot',
        BotComplete: 'BotComplete',
        ButtonSelectMe: 'ButtonSelectMe',
        ButtonSelectOther: 'ButtonSelectOther',
        BotMade: 'BotMade',
        BotLink: 'BotLink',
        SelectSponsor: 'SelectSponsor',
        FindSponser: 'FindSponser',
        CopyLink: 'CopyLink',
        Card: 'Card',
        CardComment: 'CardComment',
        CardCaution: 'CardCaution',
        SearchComment: 'SearchComment',
        PlaceholderID: 'PlaceholderID',
        NotEmpty: 'NotEmpty',
        NotFound: 'NotFound',
        Copied: 'Copied',
        OtherHuwonComplete: 'OtherHuwonComplete',
        YouCant: 'YouCant',
        InviteOther: 'InviteOther',
        NotFoundID: 'NotFoundID',
    },
    tomy:{
        kr: {
            Bot: '네, 회원을 초대하려면 먼저 후원인 지정이 필요합니다. 어떤 분을 후원인으로 하시겠어요?',
            BotComplete: '{name}님을 후원인으로 설정해서 회원초대장을 만들었어요.',
            BotMade: '{name}님을 후원인으로 한 초대장을 만들었습니다.',
            BotLink: '초대장 안의 버튼을 누르면 링크가 복사되니, 초대받을 분에게 전달해주시면 됩니다.',
            ButtonSelectMe: '나를 후원인으로 지정',
            ButtonSelectOther: '다른 회원을 후원인으로 지정',
            SelectSponsor: '아래 버튼을 누르면 후원인으로 지정할 회원을 검색하실 수 있습니다.',
            FindSponser: '후원인 검색',
            CopyLink: '초대장 링크 복사',
            Card: '초대장',
            CardComment: '애터미의<br><strong>새로운 회원을 초대합니다!</strong>',
            CardCaution: '* 생성된 초대장 링크는 30분동안 유효합니다.',
            SearchComment: '상단 검색창에서 회원을 입력하세요.',
            PlaceholderID: '후원인 ID를 입력하세요.',
            NotEmpty: '죄송합니다만, {name}님은 이미 2명의 하위회원이 있기 때문에 회원초대가 어렵습니다. 하위회원이 없거나 1명인 경우에만 가능해요. 다른 회원님을 후원인으로 지정하시겠어요?',
            NotFound: '존재하지 않는 회원번호입니다.',
            Copied: '초대장 링크가 복사되었습니다.',
            OtherHuwonComplete: '후원인이 지정된 초대장을 만들었습니다. 초대장 안의 버튼을 누르면 링크가 복사되니, 초대받을 분에게 전달해주시면 됩니다.',
            YouCant: '{name}님은 이미 2명의 하위회원이 있네요. 하위회원이 없거나 1명인 경우에만 회원초대가 가능하답니다.',
            InviteOther: '다른 회원을 후원인으로 설정해서 초대하시겠어요?',
            NotFoundID: '후원인 ID를 입력하세요',
        },
        eng: {
            Bot: 'Yes, you need to designate a sponsor before you can invite members. Who would you like to designate as a sponsor?',
            BotComplete: "You've created an invitation backed by {name}}.",
            BotMade: "You've created an invitation backed by {name}}.",
            BotLink: 'You can click the button in the invitation, the link will be copied, and then you just have to pass it on to the invitee.',
            ButtonSelectMe: 'Make me a sponsor',
            ButtonSelectOther: 'Assign another member as the sponsor.',
            SelectSponsor: 'You can search for a member to designate as a sponsor by clicking the button below.',
            FindSponser: 'Sponsor search',
            CopyLink: 'Copy invitation link',
            Card: 'invitation',
            CardComment: 'We invite you to become a new member of Atomy.',
            CardCaution: '※ The generated invitation link is valid for 30 minutes.',
            SearchComment: 'Enter member name/ID in the search bar at the top.',
            PlaceholderID: 'Please enter your sponsor ID.',
            NotEmpty: "We're sorry, but it's difficult to invite members because {name} already has 2 downliners. This is possible only if there are no downliners or there is only one downliner. Would you like to designate another member as a sponsor?",
            NotFound: 'This is a non-existent member number.',
            Copied: 'The invitation link has been copied.',
            OtherHuwonComplete: 'A sponsor has created a designated invitation. If you click the button in the invitation, the link will be copied, and you just have to pass it on to the invitee.',
            YouCant: 'I am a sponsor who already has downliner. Please search again.',
            InviteOther: 'Would you like to designate another member as a sponsor?',
            NotFoundID: 'Please, enter the sponsor ID',

        },    
    },
    papa:{
        kr: {
            Bot: '오, 좋아요. 그렇다면 새로운 애터미 회원의 후원인을 먼저 지정해야겠네요. 후원인으로 누가 좋을까요? ',
            BotComplete: '{name}님을 후원인으로 설정해서 회원초대장을 만들었어요.',
            BotMade: '우리 {name}님이 후원인이네요, 좋습니다!',
            BotLink: '이제 [초대장 링크 복사]를 눌러 초대받을 사람에게 보내세요.',
            ButtonSelectMe: '나를 후원인으로 지정',
            ButtonSelectOther: '다른 회원을 후원인으로 지정',
            SelectSponsor: '후원인으로 지정할 회원을 검색해볼까요?',
            FindSponser: '후원인 검색',
            CopyLink: '초대장 링크 복사',
            Card: '초대장',
            CardComment: '애터미의<br><strong>새로운 회원을 초대합니다!</strong>',
            CardCaution: '* 생성된 초대장 링크는 30분동안 유효합니다.',
            SearchComment: '상단 검색창에서 회원을 입력하세요.',
            PlaceholderID: '후원인 ID를 입력하세요.',
            NotEmpty: '{name}님은 후원인 지정이 불가능합니다. 하위회원이 없거나 1명일 경우에만 초대가 가능하답니다. 다른 회원을 후원인으로 지정하는 게 좋겠어요.',
            NotFound: '존재하지 않는 회원번호입니다.',
            Copied: '초대장 링크가 복사되었습니다.',
            OtherHuwonComplete: '후원인이 지정된 초대장이에요. 초대장 안 버튼을 누르면 링크 복사가 가능하답니다. 복사한 링크를 받은 사람은 새로운 애터미인이 될 수 있어요.',
            YouCant: '{name}님은 이미 2명의 하위회원이 있네요. 하위회원이 없거나 1명인 경우에만 회원초대가 가능하답니다.',
            NotFoundID: '후원인 ID를 입력하세요',
            InviteOther: '다른 회원을 후원인으로 설정해서 초대하시겠어요?',
        },
        eng: {
            Bot: 'Oh, good. If so, you must first designate a sponsor for the new Atomy member. Who would be a good sponsor?',
            BotComplete: 'Our {name} is a sponsor, great!',
            BotMade: '{name} is a sponsor, great!',
            BotLink: 'Now, click [Copy invitation link] to send it to the invitee.',
            ButtonSelectMe: 'Make me a sponsor',
            ButtonSelectOther: 'Assign another member as the sponsor.',
            SelectSponsor: 'Shall we search for a member to designate as a sponsor?',
            FindSponser: 'Sponsor search',
            CopyLink: 'Copy invitation link',
            Card: 'invitation',
            CardComment: 'We invite you to become a new member of Atomy.',
            CardCaution: '※ The generated invitation link is valid for 30 minutes.',
            SearchComment: 'Enter member name/ID in the search bar at the top.',
            PlaceholderID: 'Please enter your sponsor ID.',
            NotEmpty: 'You cannot designate a sponsor for {name}. Invitation is possible only if there are no downliners or only one downliner. It would be better to designate another member as a sponsor.',
            NotFound: 'This is a non-existent member number.',
            Copied: 'The invitation link has been copied.',
            OtherHuwonComplete: 'This is an invitation with a designated sponsor. You can copy the link by clicking the button inside the invitation. The person who receives the copied link can become a new Atomy.',
            YouCant: 'I am a sponsor who already has downliner. Please search again.',
            NotFoundID: 'Please, enter the sponsor ID',
            InviteOther: 'It would be better to designate another member as a sponsor.',
        },    
    },
};
